import { render, staticRenderFns } from "./return-register.vue?vue&type=template&id=f517c832&"
import script from "./return-register.vue?vue&type=script&lang=js&"
export * from "./return-register.vue?vue&type=script&lang=js&"
import style0 from "./return-register.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports